import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import UserFormSections from "./UserFormSections.js"


class Lock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            grupo_id: null,
            departamento_id: null,
            departamentopadre_id: null,
            pk: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }


    ResetForm() {
        this.setState({
            grupo_id: null,
            departamento_id: null,
            departamentopadre_id: null,
            pk: null,
        });
    }

    setSelects(data) {
        this.setState({
            pk: data.pk,
            grupo_id: data.grupo_id,
            departamento_id: data.departamento_id,
            departamentopadre_id: data.departamentopadre_id,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.usuarios.lock}
                postUrl={api.usuarios.usuarios.lock}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Usuario ha sido deshabilitado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Deshabilitar login de Usuario"}
                buttonTitle={"Deshabilitar login Usuario"}
                buttonIcon={"fa fa-lock fa-lg"}
                className={"ui-modal-dialog ui-modal-lg"}

                saveButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.ResetForm()}
                closeButton={true}>
                <div className="ui-form">
                    <div className="ui-alert ui-alert-warning">
                        <i className="ti ti-lock" aria-hidden="true"></i>
                        Se deshabilitará el login del usuario seleccionado.
                    </div>
                    <UserFormSections
                        disabled={true}
                        departamentoId={this.state.departamento_id}
                        departamentoPadreId={this.state.departamentopadre_id}
                        onGrupoChange={(data) => this.setState({ departamentopadre_id: (data != null ? data.pk : 0), departamento_id: null })}
                        onSubgrupoChange={(data) => this.setState({ departamento_id: (data != null ? data.pk : 0) })}
                    />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Lock;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Usuarios/Lock.js